export default {"src":"/_next/static/media/auth.8bf83ba5.svg","height":413,"width":682};